<template>
	<BaseModal
			:show="show"
			title="Are you sure you want to reset this display?"
			confirmText="Yes"
			cancelText="No"
			:useTimer="true"
			@confirm="$emit('confirm')"
			@cancel="handleCancel"
			ref="baseModal"
	>
		This cannot be undone. You will have to re-pair this display via buzztime remote.
	</BaseModal>
</template>

<script setup>
import {ref, watch} from 'vue';
import BaseModal from './BaseModal.vue';

const props = defineProps({
	show: {
		type: Boolean,
		default: false
	}
});

const emit = defineEmits(['confirm', 'cancel']);

const baseModal = ref(null);
const confirmButton = ref(null);
const cancelButton = ref(null);
const previouslyFocused = ref(null);

function getButtons() {
	return [confirmButton.value, cancelButton.value].filter(Boolean);
}

const handleCancel = () => {
	if (previouslyFocused.value) {
		previouslyFocused.value.focus();
	}
	emit('cancel');
};

watch(() => props.show, (newVal) => {
	if (newVal) {
		previouslyFocused.value = document.activeElement;
	} else {
		previouslyFocused.value = null;
	}
});

defineExpose({
	getButtons,
	animateModalClose: () => baseModal.value?.animateModalClose()
});
</script>